<template>
  <div class="tag-input">
    <div :class="['input', { active }]" @click="active = true">
      <label>{{ label }}</label>

      <div class="values">
        <div
          class="chip"
          v-for="(item, i) in value"
          :key="i"
          @click.stop="removeItem(i)"
        >
          <span>{{ item }}</span>

          <icon name="cancel" />
        </div>

        <input
          ref="input"
          v-model="inputString"
          @focus="onInputFocus"
          @blur="onInputBlur"
          @keydown="handleKeyDown"
        />
      </div>
    </div>
  </div>
</template>

<script>
const TAG_LIMIT = 20;

import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    value: Array,
    label: String,
  },

  data() {
    return {
      active: false,
      inputString: '',
    };
  },

  watch: {
    active(value) {
      if (value) {
        this.$refs.input.focus();
      } else {
        this.inputString = '';
        this.$refs.input.blur();
      }
    },
  },

  methods: {
    handleAddValue(newValue) {
      const values = [...this.value];

      if (!values.includes(newValue) && values.length < TAG_LIMIT) {
        values.push(newValue);
        this.$emit('input', values);
      }

      this.$refs.input.focus();

      setTimeout(() => {
        this.inputString = '';
      });
    },

    removeItem(index) {
      const values = [...this.value];

      values.splice(index, 1);
      this.$emit('input', values);
    },

    handleKeyDown(e) {
      try {
        switch (e.keyCode) {
          case 8:
            if (!this.inputString) {
              this.removeItem(this.value.length - 1);
            }
            break;
          case 13:
          case 9:
          case 188:
            const newValue = this.inputString.replace(/[\W]+/g, '');

            if (newValue) {
              this.handleAddValue(newValue);
              e.preventDefault();
            }
            break;
        }
      } catch (e) {
        // swallow
      }
    },

    onInputFocus() {
      this.active = true;
    },

    onInputBlur() {
      this.active = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-input {
  margin-bottom: var(--multiselect-margin-bottom, $gp);
  position: relative;
}

.input {
  background-color: var(--theme-background);
  border: solid 1px var(--theme-input-border);
  border-radius: $border-radius;
  width: 100%;
  min-height: 46px;
  padding: calc(#{$gp * .5} - 2px);
  display: flex;
  align-items: center;

  &.active {
    border-color: $color-green-1;
  }

  label {
    color: $color-gray-5;
    background-color: var(--theme-background);
    font-size: 12px;
    position: absolute;
    top: -8px;
    left: $gp * .75;
    font-weight: bold;
    padding: 0 3px;
  }
}

.values {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}

.chip {
  background-color: var(--theme-pill);
  height: 24px;
  padding: 0 $gp * .25 0 $gp * .5;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  margin: 2px;
  font-size: 14px;

  &:hover {
    background-color: var(--theme-pill-hover);
  }

  .icon {
    font-size: 16px;
    margin-left: $gp * .25;
  }
}

input {
  border: none;
  background-color: transparent;
  flex: 1;
  min-width: 100px;
}
</style>
